import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import './video-card.scss';
import './video-card.responsive.scss';

import Modal from '../modal/modal';

const VideoCard = (props) => {
    let folderName;
    const [launchPopUpVisible, setLaunchPopUpVisible] = useState(false);
    const [dimensions, setDimensions] = React.useState({
        height: window.innerHeight,
        width: window.innerWidth,
    });

    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        }, 1000);

        window.addEventListener('resize', debouncedHandleResize);

        return (_) => {
            window.removeEventListener('resize', debouncedHandleResize);
        };
    });

    function debounce(fn, ms) {
        let timer;
        return (_) => {
            clearTimeout(timer);
            timer = setTimeout((_) => {
                timer = null;
                fn.apply(this, arguments);
            }, ms);
        };
    }

    let vidStyle;
    if (dimensions.width > 320 && dimensions.width < 768) {
        // folderName = 'mob';
        vidStyle = { marginTop: '30%', width: '85%' };
    } else if (dimensions.width > 767 && dimensions.width < 1170) {
        // folderName = 'ipad';
        vidStyle = { marginTop: '10%', width: '85%' };
    } else if (dimensions.width > 1169 && dimensions.width < 1700) {
        // folderName = '1280';
        vidStyle = { marginTop: '5%', width: '70%' };
    } else {
        // folderName = '1920';
        vidStyle = { marginTop: '1%', width: '75%' };
    }
    folderName = '1920';

    const startVideo = () => {
        // const script = document.createElement('script');
        // script.src = './static/data/GA.js';
        // script.async = true;
        // document.body.appendChild(script);
        setLaunchPopUpVisible(true);
    };

    const initOrCancelLaunchPopUp = (action) => {
        if (action) {
            setLaunchPopUpVisible(true);
        } else {
            setLaunchPopUpVisible(false);
        }
    };

    const renderVideoModal = () => {
        return (
            <Modal
                visible={launchPopUpVisible}
                isClose={true}
                onClose={() => {
                    initOrCancelLaunchPopUp(false);
                }}
                contentClass="strt-req-confirm-content"
            >
                <video
                    controlsList="nodownload"
                    style={vidStyle}
                    id="catiavideo"
                    onContextMenu={(e) => {
                        e.preventDefault();
                        return false;
                    }}
                    controls
                    autoPlay
                    playsInline
                    id="vdo"
                >
                    <source
                        src={`static/data/${props.video}`}
                        type="video/mp4"
                    ></source>
                </video>
            </Modal>
        );
    };

    return (
        <div className="video-card">
            <div className="top" onClick={startVideo}>
                <img
                    src={`static/img/${folderName}/${props.thumb}`}
                    style={{ width: '100%', border: '1px solid #eee' }}
                />
                {/* <div className="play-icon"></div> */}
                <img
                    src={`./static/img/${folderName}/play_icon_gray.svg`}
                    className="play-icon gray"
                />
                <img
                    src={`./static/img/${folderName}/play_icon_blue.svg`}
                    className="play-icon blue"
                />
            </div>
            {/* <div className="bottom">
                <div className="right">
                    <img src={`./static/img/icons/${folderName}/${props.icon}`}></img>
                    <span className="app-name">{props.appName}</span>
                </div>
                <div className="left">
                    <img src={`./static/img/icons/${folderName}/duration.svg`} className="dur-icon"/>
                    <span className="dur-val">{props.duration}</span>
                </div>
            </div> */}
            {renderVideoModal()}
        </div>
    );
};

VideoCard.propTypes = {
    thumb: PropTypes.string,
    appName: PropTypes.string,
    duration: PropTypes.string,
    icon: PropTypes.string,
    video: PropTypes.string,
};

export default VideoCard;
